import {course_getCourseById_Api,} from 'apis'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {getId, getType} from "../../../../apis/model/base";
import {CourseActionTypes} from "../index";
import {Modal} from "antd";
import {FullSideModalLayout} from "../../../../components/Modal/SideModalLayout";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {CourseClassList} from "./CourseClassForm";
import LoadingBlock from "../../../Loading/LoadingBlock";
import _ from "lodash";
import {CourseSubjectList} from "../CourseSet/CourseSubjectForm";
import {CourseTeachers} from "../CourseSet/containers/CourseTeachers";
import {CopyCourseModal, CreateCourseModal, EditCourseModal, PromoteStudentsWizard} from "../CourseSet/CourseSetForm";
import Async from "../../../../modules/asyncCache/components/Async";
import {bindQueryParam} from "../../functions/routerHelper";
import {CourseMergeMedal} from "../CourseSet/CourseMedalForm";
import {useCourseApi} from "./useCourseApi";
import {useData} from "../../AdminPanel";

export const useCourseForm = ({
                                  owner_type, owner_id
                              }) => {
    const t = useTranslate()
    const [refreshKey, setRefreshKey] = useState()
    const onError = notifyOnError(t)
    const onRefresh = () => {
        setRefreshKey(Date.now())
    }
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const [actionIO, setActionIO] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        onCourseCreate,
        onCourseUpdate,
        grantCertificateToStudentInCourse, revokeCertificateFromStudentInCourse, issueThirdCertificateIfEligible,
        onCourseDuplicate, onCourseDelete, onCoursePromote, isPromoting,
        confirmCourseDelete,
        confirmGrantCertificateToStudentInCourse, confirmRevokeCertificateFromStudentInCourse,
        refreshKey: refreshKeyFromApi
    } = useCourseApi({owner_id, owner_type})
    useEffect(() => {
        setRefreshKey(refreshKeyFromApi)
    }, [refreshKeyFromApi])

    const wasPromotingRef = useRef(false)
    useEffect(() => {
        if (isPromoting) {
            wasPromotingRef.current = true
        } else if (wasPromotingRef.current) {
            wasPromotingRef.current = false
            if (action?.type === CourseActionTypes.COURSE_PROMOTE) {
                onCancel()
            }
        }
    }, [isPromoting])

    const [modalIO, {onExport = NullAsDefault, onImport = NullAsDefault}] = useData({item: actionIO?.value ?? {}})
    useEffect(() => {
        switch (actionIO?.type) {
            case "COURSE_ATTENDANCE_EXPORT":
            case "COURSE_GRADE_EXPORT":
            case "COURSE_STUDENT_EXPORT":
                onExport(actionIO?.type)
                break
            case "COURSE_ATTENDANCE_IMPORT":
            case "COURSE_GRADE_IMPORT":
            case "COURSE_STUDENT_IMPORT":
                onImport(actionIO?.type)
                break
            default:
                break
        }
    }, [actionIO])

    const handleAction = (action, params) => {
        const [id, prop] = [getId(params), getType(params)]
        switch (action) {
            case CourseActionTypes.SHOW_CLASS_LIST_MODAL:
            case CourseActionTypes.SHOW_SUBJECT_LIST_MODAL:
            case CourseActionTypes.SHOW_TEACHER_LIST_MODAL:
            case CourseActionTypes.COURSE_CREATE:
            case CourseActionTypes.COURSE_COPY:
            case CourseActionTypes.COURSE_PROMOTE:
            case CourseActionTypes.COURSE_UPDATE:
            case "COURSE_MEDAL_ISSUE_IF_ELIGIBLE":
                setAction({type: action, value: params})
                break
            case CourseActionTypes.COURSE_DELETE:
                confirmCourseDelete(id)
                break
            case "COURSE_MEDAL_GRANT_TO_ALL_STUDENTS":
                confirmGrantCertificateToStudentInCourse(id)
                break
            case "COURSE_MEDAL_REVOKE_ALL_TO_STUDENTS":
                confirmRevokeCertificateFromStudentInCourse(id)
                break
            case "COURSE_ATTENDANCE_EXPORT":
            case "COURSE_GRADE_EXPORT":
            case "COURSE_STUDENT_EXPORT":
                setActionIO({type: action, value: params})
                break
            case "COURSE_ATTENDANCE_IMPORT":
            case "COURSE_GRADE_IMPORT":
            case "COURSE_STUDENT_IMPORT":
                setActionIO({type: action, value: params})
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {title: undefined}
        let modal_params = {}
        switch (action?.type) {
            case CourseActionTypes.SHOW_CLASS_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('list of classes')}
                            </div>
                        }
                        onCancel={onCancel}>
                        {bindingSearch({
                            onCancel,
                            owner_id,
                            owner_type,
                            item: action?.value,
                        })(CourseClassList)}
                    </FullSideModalLayout>
                )
            case CourseActionTypes.SHOW_SUBJECT_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('list of subjects')}
                            </div>
                        }
                        onCancel={onCancel}>
                        {bindingSearch({
                            onCancel,
                            owner_id,
                            owner_type,
                            item: action?.value,

                        })(CourseSubjectList)}
                    </FullSideModalLayout>
                )
            case CourseActionTypes.SHOW_TEACHER_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('list of teachers')}
                            </div>
                        }
                        onCancel={onCancel}>
                        {bindingSearch({
                            onCancel,
                            owner_id,
                            owner_type,
                            item: action?.value,
                        })(CourseTeachers)}
                    </FullSideModalLayout>
                )
            case CourseActionTypes.COURSE_CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create course')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCourseCreate(values)
                        onCancel()
                    },
                }
                modal_params = {
                    width: 720,
                    maskClosable: true,
                }
                Content = CreateCourseModal
                break
            case CourseActionTypes.COURSE_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update course')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCourseUpdate(values, {id})
                        onCancel()
                    },
                }
                modal_params = {
                    width: 800,
                    maskClosable: false,
                }
                Content = EditCourseModal
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: course_getCourseById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            case "COURSE_MEDAL_ISSUE_IF_ELIGIBLE":
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('issue 3rd certificate')}
                    </div>
                )
                params = {
                    onCancel,
                    course: action?.value,
                    onSubmit: (values) => {
                        issueThirdCertificateIfEligible(values, {id})
                        onCancel()
                    },
                }
                modal_params = {
                    width: 640,
                    maskClosable: false,
                }
                Content = CourseMergeMedal
                break
            case CourseActionTypes.COURSE_COPY:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('duplicate')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCourseDuplicate(values, {id})
                        onCancel()
                    },
                }
                modal_params = {
                    width: 640,
                    maskClosable: false,
                }
                Content = CopyCourseModal
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: course_getCourseById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            case CourseActionTypes.COURSE_PROMOTE:
                return (
                    <Modal
                        footer={null}
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('promote students')}
                            </div>
                        }
                        onCancel={onCancel}
                        open={!!action?.type}
                        destroyOnHidden={true}
                        className="custom-modal"
                        width={820}>
                        <PromoteStudentsWizard
                            owner_id={owner_id}
                            owner_type={owner_type}
                            course_id={id}
                            isSubmitting={!!isPromoting}
                            onCancel={onCancel}
                            onSubmit={(values) => {
                                onCoursePromote(values, {id})
                            }}
                        />
                    </Modal>
                )
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                // maskClosable={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    return {
        modal,
        modalIO,
        onCancel,
        handleAction,
        refreshKey
    }
}
